import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Padlock — body is a rounded rectangle beneath a U-shaped shackle.
 *  The keyhole is implied by the closed silhouette so the icon stays
 *  calm at 14×14. Used for "lock comments" and similar hardening
 *  affordances. */
export function IcnLock(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="lock">
      <rect x="3.5" y="7.5" width="9" height="6.5" rx="1.2" />
      <path d="M5.5 7.5V5.25A2.5 2.5 0 0 1 8 2.75a2.5 2.5 0 0 1 2.5 2.5V7.5" />
      <line x1="8" y1="10" x2="8" y2="12" />
    </Svg>
  );
}
